import { useMemo } from 'react';
import Helmet from '../lib/Helmet';
import * as HL from '../lib/heatLoad';
import { CATALOGUE } from '../data/catalogue';
import { PRICES, STOCK } from '../data/pricing';
import { SERIES } from '../data/highlights';
import { STATIONS } from '../data/indiaClimate';
import { AC_SPECS } from '../data/acSpecs';
import { roomACs, momentCheck } from '../data/roomDay';
import { pickGuideModels, usedSources } from '../data/guideInverter';
import {
  DIFF_SEO, DIFF_UPDATED, DIFF_SOURCES, MOMENTS, NIGHT, SPEED_CAPTIONS, INSIDE_CAPTIONS, diffContent,
} from '../data/guideDifference';
import { GuideHeader, GuideBody } from '../components/guide/GuideParts';
import CompressorExplainer from '../components/guide/CompressorExplainer';
import FrequencyExplainer from '../components/guide/FrequencyExplainer';
import InsideExplainer from '../components/guide/InsideExplainer';

// Route: /blog/difference-between-inverter-and-non-inverter-ac — AC guide 3,
// the "how it works" guide, rebuilt 20 Oct 2026 to GUIDES_PLAYBOOK.md
// section 3. Which one to buy is guide 1. Every word comes from diffContent()
// in data/guideDifference.js, which scripts/guide-pages.js reads too.

export default function DifferenceGuide() {
  const { c, acs, moments, S } = useMemo(() => {
    const g = pickGuideModels({ catalogue: CATALOGUE, prices: PRICES, stock: STOCK, series: SERIES });
    const a = roomACs({ catalogue: CATALOGUE, prices: PRICES, stock: STOCK, series: SERIES, specs: AC_SPECS });
    const pair = [a.fixed, a.three].filter(Boolean);
    const ms = MOMENTS.map((m) => ({ ...m, ...momentCheck(HL, STATIONS[m.room.city], m.room, m.h, pair) }));
    const night = pair.length === 2 ? momentCheck(HL, STATIONS[NIGHT.room.city], NIGHT.room, NIGHT.h, pair) : null;
    const content = diffContent(g, AC_SPECS, night);
    return { c: content, acs: a, moments: ms, S: usedSources(DIFF_SOURCES, content) };
  }, []);

  const extras = {
    0: acs.fixed && acs.three
      ? <FrequencyExplainer fixed={acs.fixed} inverter={acs.three} moments={moments} sources={S}
          watch={{ title: 'Watch: how an inverter changes its speed', captions: SPEED_CAPTIONS }} />
      : null,
    1: <InsideExplainer sources={S} watch={{ title: 'Watch: what is inside each outdoor unit', captions: INSIDE_CAPTIONS }} />,
  };

  return (
    <>
      <Helmet>
        <title>{DIFF_SEO.title}</title>
        <meta name="description" content={DIFF_SEO.meta} />
        <meta property="og:title" content={DIFF_SEO.title} />
        <meta property="og:description" content={DIFF_SEO.meta} />
      </Helmet>
      <main className="bg-white pb-16 pt-16 lg:pt-20">
        <article className="mx-auto max-w-[760px] px-4 text-base leading-relaxed text-gray-900">
          <GuideHeader seo={DIFF_SEO} updated={DIFF_UPDATED} crumb={DIFF_SEO.crumb} />
          <GuideBody c={c} sources={S} current="difference-between-inverter-and-non-inverter-ac" ctaSource="guide_difference"
            watch={<CompressorExplainer watch={c.watch} sources={S} />} extras={extras} />
        </article>
      </main>
    </>
  );
}
